import { observer } from 'mobx-react';
import { FC, Fragment, useEffect, useState } from 'react';
import { tokens } from '@servicetitan/tokens';
import { useDependencies } from '@servicetitan/react-ioc';
import { BodyText, Icon, Link, Stack } from '@servicetitan/design-system';
import { TenantsStore } from '../../stores/tenants.store';

export const EmptyState: FC = observer(() => {
    const [{ resetFilters, tableState, statusesFilter, partnersFilter, searchFilter }] =
        useDependencies(TenantsStore);

    const [isFiltered, setIsFiltered] = useState(false);

    useEffect(() => {
        setIsFiltered(!!(statusesFilter.length || partnersFilter.length || searchFilter));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableState.data]);

    return isFiltered ? (
        <Stack
            spacing={2}
            className="p-y-3"
            direction="column"
            alignItems="center"
            justifyContent="center"
        >
            <Icon name="not_interested" size={40} color={tokens.colorRed500} />
            <BodyText subdued>
                No results found. Please modify your search.{' '}
                <Link primary onClick={resetFilters}>
                    Reset.
                </Link>
            </BodyText>
        </Stack>
    ) : (
        <Fragment>No records available</Fragment>
    );
});
